import React, { useEffect, useRef, useState } from 'react';
import './App.css';

function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  // Menu mobile
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  // Gamificação (mock simples)
  const [agreementsCount, setAgreementsCount] = useState<number>(() => {
    const v = localStorage.getItem('agreementsCount');
    return v ? parseInt(v, 10) : 0;
  });
  const earnedBadges = [
    { id: 'starter', label: 'Início Organizado', icon: '🎉', unlocked: agreementsCount >= 1 },
    { id: 'streak3', label: 'Trinca de Acordos', icon: '🥉', unlocked: agreementsCount >= 3 },
    { id: 'streak7', label: 'Semanas em Dia', icon: '🥈', unlocked: agreementsCount >= 7 },
    { id: 'streak15', label: 'Consistência Ouro', icon: '🥇', unlocked: agreementsCount >= 15 },
  ];
  const markAgreement = () => {
    const next = agreementsCount + 1;
    setAgreementsCount(next);
    localStorage.setItem('agreementsCount', String(next));
  };

  // Comunidade (depoimentos simples)
  type Post = { id: string; nome: string; mensagem: string; createdAt: number };
  const [posts, setPosts] = useState<Post[]>(() => {
    try {
      const raw = localStorage.getItem('communityPosts');
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const addPost = (nome: string, mensagem: string) => {
    const novo: Post = { id: String(Date.now()), nome, mensagem, createdAt: Date.now() };
    const next = [novo, ...posts].slice(0, 20);
    setPosts(next);
    localStorage.setItem('communityPosts', JSON.stringify(next));
  };

  // Lead magnet (e-book)
  const [ebookEmail, setEbookEmail] = useState<string>('');
  const [ebookOK, setEbookOK] = useState<boolean>(false);
  const handleEbook = (e: React.FormEvent) => {
    e.preventDefault();
    if (!ebookEmail) return;
    try {
      const key = 'ebookEmails';
      const list = JSON.parse(localStorage.getItem(key) || '[]');
      list.push({ email: ebookEmail, at: Date.now() });
      localStorage.setItem(key, JSON.stringify(list));
      setEbookOK(true);
    } catch {
      setEbookOK(true);
    }
  };

  // Banner rotativo (topo)
  type Slide = { desktop: string; mobile: string };
  const slides = useRef<Slide[]>([
    { desktop: '/assets/images/banners/banner1.svg', mobile: '/assets/images/banners/mobile/banner1.svg' },
    { desktop: '/assets/images/banners/banner2.svg', mobile: '/assets/images/banners/mobile/banner2.svg' },
    { desktop: '/assets/images/banners/banner3.svg', mobile: '/assets/images/banners/mobile/banner3.svg' },
    { desktop: '/assets/images/banners/banner4.svg', mobile: '/assets/images/banners/mobile/banner3.svg' },
  ]);
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const total = slides.current.length;

  const goto = (idx: number) => setCurrent(((idx % total) + total) % total);
  const prev = () => goto(current - 1);
  const next = () => goto(current + 1);

  useEffect(() => {
    if (isPaused) return;
    const id = setInterval(() => setCurrent((c) => (c + 1) % total), 5000);
    return () => clearInterval(id);
  }, [isPaused, total]);

  const toggleFaq = (idx: number) => setOpenFaq(openFaq === idx ? null : idx);

  return (
    <div>
      <a href="#home" className="skip-link">Pular para o conteúdo</a>
      {/* Header */}
      <header className="header" role="banner">
        <div className="container navbar">
          {/* Botão Hamburguer (mobile) */}
          <button
            className="hamburger"
            aria-label="Abrir menu"
            aria-controls="mobile-menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span className="bar" aria-hidden="true"></span>
            <span className="bar" aria-hidden="true"></span>
            <span className="bar" aria-hidden="true"></span>
          </button>

          <a href="#home" className="brand" aria-label="Parenzo">
            <img src="/assets/images/logo.png" alt="Parenzo" height={35} decoding="async" />
            <span className="brand-text">Parenzo</span>
          </a>

          {/* Navegação Desktop */}
          <nav className="navlinks" aria-label="Navegação principal">
            <a href="#funcionalidades">Funcionalidades</a>
            <a href="#profissionais">Profissionais</a>
            <a href="#planos">Planos</a>
            <a href="#sobre">Sobre</a>
            <a href="#faq">FAQ</a>
            <a href="#contato">Contato</a>
          </nav>
          <div className="navlinks" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <a className="btn ghost" href="#planos">Comece Agora</a>
          </div>
        </div>

          {/* Menu Mobile (dropdown) */}
          <div id="mobile-menu" className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
              <div className="container">
                  <a href="#funcionalidades" onClick={() => setMenuOpen(false)}>Funcionalidades</a>
                  <a href="#profissionais" onClick={() => setMenuOpen(false)}>Profissionais</a>
                  <a href="#planos" onClick={() => setMenuOpen(false)}>Planos</a>
                  <a href="#sobre" onClick={() => setMenuOpen(false)}>Sobre</a>
                  <a href="#faq" onClick={() => setMenuOpen(false)}>FAQ</a>
                  <a href="#contato" onClick={() => setMenuOpen(false)}>Contato</a>
              </div>
          </div>
      </header>


      {/* Banner rotativo topo */}
      <section className="banner" aria-label="Promoções e destaques" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
        <div className="container">
          <div className="carousel" role="region" aria-roledescription="carousel" aria-label="Banner rotativo">
            <div className="slides" style={{ transform: `translateX(-${current * 100}%)` }}>
              {slides.current.map((slide, idx) => (
                <div className="slide" key={slide.desktop} aria-hidden={current !== idx}>
                  <picture>
                    <source media="(max-width: 839px)" srcSet={slide.mobile} />
                    <img src={slide.desktop} alt="Banner Parenzo" loading="eager" />
                  </picture>
                </div>
              ))}
            </div>
            <button className="nav prev" aria-label="Anterior" onClick={prev}>‹</button>
            <button className="nav next" aria-label="Próximo" onClick={next}>›</button>
            <div className="dots" role="tablist" aria-label="Indicadores de slides">
              {slides.current.map((_, idx) => (
                <button
                  key={idx}
                  className={"dot" + (current === idx ? " active" : "")}
                  role="tab"
                  aria-selected={current === idx}
                  aria-label={`Ir para o slide ${idx + 1}`}
                  onClick={() => goto(idx)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Hero */}
      <main id="home" className="hero" role="main">
        <div className="container">
          <h1>Cuidar dos filhos juntos ficou mais fácil.</h1>
          <p className="lead">A Parenzo ajuda pais separados a organizarem visitas, pensão e acordos de guarda com transparência e equilíbrio.</p>
          <div className="hero-cta" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <a href="https://apps.apple.com/us/app/parenzo-co-parentalidade/id6752611087" target="_blank" rel="noopener noreferrer" aria-label="Baixar na App Store" style={{ lineHeight: 0 }}>
              <img src="/assets/images/badges/app-store-badge.svg" alt="Baixar na App Store" height={40} loading="lazy" decoding="async" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=br.com.parenzo.customer" target="_blank" rel="noopener noreferrer" aria-label="Disponível no Google Play" style={{ lineHeight: 0 }}>
              <img src="/assets/images/badges/google-play-badge.svg" alt="Disponível no Google Play" height={40} loading="lazy" decoding="async" />
            </a>
            <a className="btn secondary" href="#planos">Comece Agora</a>
          </div>

          <section aria-labelledby="destaques-title" style={{marginTop: 32}}>
            <h2 id="destaques-title" className="visually-hidden">Destaques</h2>
            <div className="highlights">
              <div className="card">
                <div className="icon" style={{background: 'var(--green)'}}>📅</div>
                <h3>Calendário de Visitas</h3>
                <p>Agende visitas, compromissos e atividades com clareza para todos.</p>
              </div>
              <div className="card">
                <div className="icon" style={{background: 'var(--blue)'}}>💳</div>
                <h3>Controle de Despesas</h3>
                <p>Registre, divida e comprove pagamentos de pensão e custos extras.</p>
              </div>
              <div className="card">
                <div className="icon" style={{background: 'var(--lilac)'}}>🔒</div>
                <h3>Comunicação Segura</h3>
                <p>Troca de mensagens organizada e registrada para evitar conflitos.</p>
              </div>
            </div>
          </section>

        </div>
      </main>

      {/* Funcionalidades */}
      <section id="funcionalidades" aria-labelledby="func-title">
        <div className="container">
          <h2 id="func-title">Tudo o que você precisa em um só lugar.</h2>
          <div className="features-grid">
            <div className="card">
              <h3>📅 Calendário Compartilhado</h3>
              <p>Planeje visitas, compromissos e atividades de forma transparente, sem conflitos.</p>
            </div>
            <div className="card">
              <h3>💰 Gestão de Despesas</h3>
              <p>Registre, divida e acompanhe pensão e outros custos da rotina dos filhos.</p>
            </div>
            <div className="card">
              <h3>💬 Comunicação Segura</h3>
              <p>Troque mensagens de forma organizada e centralizada, sem ruídos.</p>
            </div>
            <div className="card">
              <h3>📂 Documentos e Acordos</h3>
              <p>Guarde termos, comprovantes e registros importantes em um só lugar.</p>
            </div>
            <div className="card">
              <h3>⚖️ Apoio Jurídico (opcional, se fizer parte do negócio)</h3>
              <p>Tenha acesso a orientações legais com advogados parceiros.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Gamificação */}
      <section id="gamificacao" aria-labelledby="gamificacao-title">
        <div className="container">
          <h2 id="gamificacao-title">Gamificação</h2>
          <p className="lead">Ganhe badges ao manter acordos organizados e cumpridos. Isso incentiva a consistência e celebra pequenas vitórias.</p>
          <div className="features-grid">
            {earnedBadges.map((b) => (
              <div key={b.id} className="card" aria-live="polite">
                <div className="icon" style={{background: b.unlocked ? 'var(--green)' : 'var(--tertiary)'}}>{b.icon}</div>
                <h3 style={{marginTop: 0}}>{b.label}</h3>
                <p style={{marginBottom:0}}>{b.unlocked ? 'Desbloqueado 🎉' : 'Bloqueado — siga cumprindo acordos'}</p>
              </div>
            ))}
          </div>
          <div className="hero-cta" style={{marginTop: 12}}>
            <button className="btn primary" onClick={markAgreement}>
              Marcar acordo cumprido ({agreementsCount})
            </button>
            <button className="btn ghost" onClick={() => {localStorage.removeItem('agreementsCount'); setAgreementsCount(0);}}>
              Resetar progresso
            </button>
          </div>
        </div>
      </section>

      {/* Área para Profissionais */}
      <section id="profissionais" aria-labelledby="pros-title">
        <div className="container">
          <div>
            <p className="badge">Para Advogados e Psicólogos</p>
            <h2 id="pros-title">Área para Profissionais</h2>
            <p className="lead">Monetização com credibilidade. Conecte-se com famílias que precisam de apoio jurídico e psicológico dentro do app.</p>

            <div className="features-grid">
                    <div className="pros-point">
                        <div className="icon" style={{background:'var(--blue)'}}>🤝</div>
                        <div>
                            <h3>Conexão direta com famílias</h3>
                            <p>Receba solicitações qualificadas de pais e mães que já utilizam a Parenzo e precisam de orientação profissional.</p>
                        </div>
                    </div>
                    <div className="pros-point">
                        <div className="icon" style={{background:'var(--green)'}}>🧭</div>
                        <div>
                            <h3>Atendimento dentro do fluxo do app</h3>
                            <p>Com histórico organizado (calendário, despesas e acordos), você ganha contexto e reduz retrabalho.</p>
                        </div>
                    </div>
                    <div className="pros-point">
                        <div className="icon" style={{background:'var(--lilac)'}}>🎯</div>
                        <div>
                            <h3>Visibilidade e reputação</h3>
                            <p>Perfil verificado, avaliações de clientes e destaque por especialidade aumentam sua autoridade.</p>
                        </div>
                    </div>

                <div className="pros-cards">
                    <div className="card">
                        <h3>Benefícios para Profissionais</h3>
                        <ul className="benefits">
                            <li>Novos clientes qualificados, com demandas reais.</li>
                            <li>Maior visibilidade para sua especialidade e região.</li>
                            <li>Apoio direto às famílias em co-parentalidade.</li>
                            <li>Agenda e registros organizados para embasar atendimentos.</li>
                            <li>Canal seguro e centralizado de comunicação.</li>
                        </ul>
                    </div>
                    <div className="card">
                        <h3>Como a conexão acontece</h3>
                        <p>As famílias podem buscar profissionais por especialidade, cidade e disponibilidade. Você recebe um contato dentro do app e pode propor atendimentos, valores e próximos passos.</p>
                    </div>
                </div>
            </div>



            <div className="hero-cta" style={{marginTop: 12}}>
              <a className="btn primary" href="#contato">Quero ser parceiro</a>
              <a className="btn secondary" href="#faq">Como funciona?</a>
            </div>
          </div>

        </div>
      </section>

      {/* Planos e Preços */}
      <section id="planos" aria-labelledby="planos-title">
        <div className="container">
          <h2 id="planos-title">Planos e Preços</h2>
          <div className="pricing">
            <div className="tier">
              <h3>Free</h3>
              <div className="price">R$ 0/mês</div>
              <ul>
                <li>Calendário básico</li>
                <li>Mensagens limitadas</li>
                <li>1 responsável por família</li>
              </ul>
              <a className="btn secondary" href="#contato">Assine Agora</a>
            </div>
            <div className="tier popular">
              <h3>Premium</h3>
              <div className="price">R$ 24,90/mês</div>
              <ul>
                <li>Calendário completo</li>
                <li>Gestão de despesas</li>
                <li>Mensagens ilimitadas</li>
                <li>Documentos e acordos</li>
                <li>Suporte prioritário</li>
              </ul>
              <a className="btn primary" href="#contato">Assine Agora</a>
            </div>
            <div className="tier">
              <h3>Familiar</h3>
              <div className="price">R$ 39,90/mês</div>
              <ul>
                <li>Tudo do Premium</li>
                <li>Até 5 membros</li>
                <li>Acesso para babysitters/avós</li>
              </ul>
              <a className="btn secondary" href="#contato">Assine Agora</a>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre Nós */}
      <section id="sobre" className="about" aria-labelledby="sobre-title">
        <div className="container">
          <h2 id="sobre-title">Sobre Nós</h2>
          <p className="lead">“A Parenzo nasceu para apoiar famílias em momentos delicados. Sabemos que a co-parentalidade pode ser desafiadora, por isso criamos uma ferramenta que organiza compromissos, reduz conflitos e coloca os filhos no centro das atenções. Nosso propósito é simplificar a gestão da guarda compartilhada e trazer mais paz para a rotina de pais e filhos.”</p>
          <div className="values">
            <div className="card"><h3>Missão</h3><p>Apoiar famílias em co-parentalidade com empatia e ferramentas simples.</p></div>
            <div className="card"><h3>Visão</h3><p>Promover bem-estar infantil e comunicação clara entre os pais.</p></div>
            <div className="card"><h3>Valores</h3><p>Empatia, segurança, praticidade e transparência.</p></div>
          </div>
        </div>
      </section>

      {/* Guias e Recursos */}
      <section id="guias" aria-labelledby="guias-title">
        <div className="container">
          <h2 id="guias-title">Guias e Recursos</h2>
          <p className="lead">Conteúdo educativo sobre guarda, pensão e comunicação saudável.</p>
          <div className="features-grid">
            <div className="card">
              <h3>⚖️ Guarda Compartilhada</h3>
              <p>Entenda modelos de guarda e como tomar decisões centradas nas crianças.</p>
              <a href="#ebook" className="btn ghost" aria-label="Baixar guia prático">Guia prático</a>
            </div>
            <div className="card">
              <h3>💰 Pensão Alimentícia</h3>
              <p>Como registrar, dividir e comprovar despesas de forma organizada.</p>
              <a href="#blog" className="btn ghost">Ler no Blog</a>
            </div>
            <div className="card">
              <h3>💬 Comunicação Saudável</h3>
              <p>Dicas de comunicação não-violenta e registro de conversas no app.</p>
              <a href="#blog" className="btn ghost">Dicas práticas</a>
            </div>
          </div>
        </div>
      </section>

      {/* Blog */}
      <section id="blog" aria-labelledby="blog-title">
        <div className="container">
          <h2 id="blog-title">Blog</h2>
          <p className="lead">Conteúdos sobre convivência, aspectos legais e bem-estar infantil.</p>
          <div className="blog-grid">
            <article className="blog-card">
              <img src="/assets/images/blog-coexist.svg" alt="Dicas de convivência" loading="lazy" />
              <h3>Dicas de Convivência</h3>
              <p>Como construir rotinas positivas entre casas.</p>
              <a href="#">Ler artigo</a>
            </article>
            <article className="blog-card">
              <img src="/assets/images/blog-legal.svg" alt="Aspectos legais" loading="lazy" />
              <h3>Aspectos Legais</h3>
              <p>Guarda compartilhada, pensão e acordos: o que saber.</p>
              <a href="#">Ler artigo</a>
            </article>
            <article className="blog-card">
              <img src="/assets/images/blog-wellbeing.svg" alt="Bem-estar infantil" loading="lazy" />
              <h3>Bem-Estar Infantil</h3>
              <p>Como apoiar as emoções das crianças em transições.</p>
              <a href="#">Ler artigo</a>
            </article>
          </div>
        </div>
      </section>

      {/* Lead Magnet: E-book */}
      <section id="ebook" aria-labelledby="ebook-title">
        <div className="container">
          <h2 id="ebook-title">E-book gratuito: Guia Prático da Guarda Compartilhada no Brasil</h2>
          <p className="lead">Baixe gratuitamente em troca do seu e-mail. Conteúdo objetivo sobre guarda, pensão e boas práticas de comunicação.</p>
          <form className="form" onSubmit={handleEbook}>
            <div>
              <label className="visually-hidden" htmlFor="ebook-email">Email</label>
              <input id="ebook-email" className="input" type="email" placeholder="Seu e-mail" value={ebookEmail} onChange={(e)=>setEbookEmail(e.target.value)} required />
            </div>
            <div className="hero-cta" style={{marginTop: 8}}>
              <button type="submit" className="btn primary">Quero o e-book</button>
              <a className="btn ghost" href="/ebook-guia.html" target="_blank" rel="noopener noreferrer">Pré-visualizar</a>
            </div>
          </form>
          {ebookOK && (
            <div className="card" role="status" style={{marginTop:12}}>
              <strong>Obrigado!</strong>
              <p style={{margin:'6px 0 0'}}>Seu e-book está liberado. Você pode abrir agora: <a href="/ebook-guia.html" target="_blank" rel="noopener noreferrer">Abrir Guia</a></p>
            </div>
          )}
        </div>
      </section>

      {/* App Download */}
      <section id="app" aria-labelledby="app-title">
        <div className="container">
          <h2 id="app-title">Baixe o App</h2>
          <p className="lead">Disponível para Android e iOS.</p>
          <div className="store-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginTop: 8 }}>
            <a href="https://apps.apple.com/us/app/parenzo-co-parentalidade/id6752611087" target="_blank" rel="noopener noreferrer" aria-label="Baixar na App Store" style={{ lineHeight: 0 }}>
              <img src="/assets/images/badges/app-store-badge.svg" alt="Baixar na App Store" height={44} loading="lazy" decoding="async" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=br.com.parenzo.customer" target="_blank" rel="noopener noreferrer" aria-label="Disponível no Google Play" style={{ lineHeight: 0 }}>
              <img src="/assets/images/badges/google-play-badge.svg" alt="Disponível no Google Play" height={44} loading="lazy" decoding="async" />
            </a>
          </div>
          <div className="testimonials">
            <div className="testimonial">“Ficou muito mais fácil organizar as visitas.” — Carla</div>
            <div className="testimonial">“Acabaram os conflitos sobre despesas.” — Rodrigo</div>
            <div className="testimonial">“A comunicação ficou clara e registrada.” — Ana</div>
          </div>
        </div>
      </section>

      {/* Comunidade */}
      <section id="comunidade" aria-labelledby="comunidade-title">
        <div className="container">
          <h2 id="comunidade-title">Comunidade</h2>
          <p className="lead">Espaço para troca de experiências e depoimentos. Mantenha o respeito e a privacidade.</p>
          <form className="form" onSubmit={(e)=>{e.preventDefault(); const form=e.target as HTMLFormElement; const nome=(form.elements.namedItem('nomeCom') as HTMLInputElement).value.trim(); const msg=(form.elements.namedItem('msgCom') as HTMLTextAreaElement).value.trim(); if(nome && msg){ addPost(nome, msg); form.reset(); }}}>
            <div>
              <label className="visually-hidden" htmlFor="nomeCom">Nome</label>
              <input id="nomeCom" name="nomeCom" className="input" placeholder="Seu nome" required />
            </div>
            <div>
              <label className="visually-hidden" htmlFor="msgCom">Depoimento</label>
              <textarea id="msgCom" name="msgCom" className="textarea" placeholder="Compartilhe sua experiência (sem dados sensíveis)" required />
            </div>
            <button className="btn secondary" type="submit">Publicar</button>
          </form>
          <div className="testimonials" style={{marginTop:16}}>
            {posts.length === 0 && <div className="testimonial">Seja o primeiro a compartilhar um depoimento.</div>}
            {posts.map((p)=> (
              <div key={p.id} className="testimonial">
                <strong>{p.nome}</strong>
                <p style={{marginTop:6}}>{p.mensagem}</p>
                <small className="legend">{new Date(p.createdAt).toLocaleDateString()}</small>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" aria-labelledby="faq-title">
        <div className="container">
          <h2 id="faq-title">Perguntas Frequentes</h2>
          {[
            {q:'Como funciona a divisão de visitas?', a:'Você define regras no calendário e pode alternar semanas, fins de semana e feriados com notificações.'},
            {q:'O app substitui um advogado?', a:'Não. Ele organiza a rotina e os registros. Para questões legais, consulte um profissional.'},
            {q:'Como dividir despesas pelo sistema?', a:'Cadastre a despesa, defina percentuais (ex.: 50/50) e anexe comprovantes.'},
            {q:'Segurança dos dados?', a:'Armazenamento seguro, criptografia em trânsito e controles de acesso por família.'}
          ].map((item, idx) => (
            <div key={idx} className="faq-item">
              <button className="faq-q" aria-expanded={openFaq===idx} onClick={() => toggleFaq(idx)}>{item.q}</button>
              {openFaq===idx && <div className="faq-a">{item.a}</div>}
            </div>
          ))}
        </div>
      </section>

      {/* Contato */}
      <section id="contato" aria-labelledby="contato-title">
        <div className="container">
          <h2 id="contato-title">Contato</h2>
          <form className="form" onSubmit={(e)=>{e.preventDefault(); alert('Mensagem enviada!');}}>
            <div>
              <label className="visually-hidden" htmlFor="nome">Nome</label>
              <input className="input" id="nome" name="nome" placeholder="Seu nome" required />
            </div>
            <div>
              <label className="visually-hidden" htmlFor="email">Email</label>
              <input className="input" id="email" name="email" type="email" placeholder="Seu email" required />
            </div>
            <div>
              <label className="visually-hidden" htmlFor="mensagem">Mensagem</label>
              <textarea className="textarea" id="mensagem" name="mensagem" placeholder="Como podemos ajudar?" required />
            </div>
            <div style={{display:'flex', gap:12, alignItems:'center', flexWrap:'wrap'}}>
              <button className="btn primary" type="submit">Enviar</button>
              <a className="btn ghost" href="https://wa.me/5545991439499" target="_blank" rel="noopener noreferrer">WhatsApp</a>
            </div>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" role="contentinfo">
        <div className="container">
          <div className="cols">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 8, minHeight: 120 }}>
              <a href="#home" aria-label="Parenzo">
                <img
                  src="/assets/images/logo_p_square.png"
                  alt="Parenzo"
                  height={100}
                  decoding="async"
                  loading="lazy"
                  style={{ display: 'block' }}
                />
              </a>
              <p style={{ color: 'var(--gray-500)', margin: 0 }}>Co-parentalidade com equilíbrio.</p>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginTop: 8 }}>
                <a href="https://apps.apple.com/us/app/parenzo-co-parentalidade/id6752611087" target="_blank" rel="noopener noreferrer" aria-label="Baixar na App Store">
                  <img src="/assets/images/badges/app-store-badge.svg" alt="Baixar na App Store" height={40} loading="lazy" decoding="async" style={{ display: 'block' }} />
                </a>
                <a href="https://play.google.com/store/apps/details?id=br.com.parenzo.customer" target="_blank" rel="noopener noreferrer" aria-label="Disponível no Google Play">
                  <img src="/assets/images/badges/google-play-badge.svg" alt="Disponível no Google Play" height={40} loading="lazy" decoding="async" style={{ display: 'block' }} />
                </a>
              </div>
            </div>
            <div>
              <h3 style={{fontSize:16}}>Links rápidos</h3>
              <nav>
                <a href="#home">Home</a><br/>
                <a href="#funcionalidades">Funcionalidades</a><br/>
                <a href="#gamificacao">Gamificação</a><br/>
                <a href="#guias">Guias</a><br/>
                <a href="#ebook">E-book</a><br/>
                <a href="#comunidade">Comunidade</a><br/>
                <a href="#planos">Planos</a><br/>
                <a href="#profissionais">Profissionais</a><br/>
                <a href="#blog">Blog</a><br/>
                <a href="#contato">Contato</a>
              </nav>
            </div>
            <div>
              <h3 style={{fontSize:16}}>Suporte</h3>
              <nav>
                <a href="#faq">FAQ</a><br/>
                <a target="_blank" href="/politica-de-privacidade.html">Política de Privacidade</a><br/>
                <a target="_blank" href="/exclusao-de-dados.html">Exclusão de Dados da Conta</a>
              </nav>
            </div>
            <div>
              <h3 style={{fontSize:16}}>Redes sociais</h3>
              <nav>
                <a href="#">Instagram</a><br/>
                <a href="#">Facebook</a><br/>
                <a href="#">LinkedIn</a>
              </nav>
            </div>
          </div>
          <p style={{marginTop: 16, color:'var(--gray-500)'}}>© {new Date().getFullYear()} Parenzo. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
